import { makeStyles } from '@material-ui/core/styles';
import { primaryText } from '../../utils/CssGlobalVariables';

export const useStyle = makeStyles(theme => ({
    paper: {
        [theme.breakpoints.up(1250 + theme.spacing(3) * 2)]: {

        },
    },
    layout: {
        width: 'auto',
        marginLeft: theme.spacing(2),
        marginRight: theme.spacing(2),
        [theme.breakpoints.up(1250 + theme.spacing(2) * 2)]: {
            width: 1250,
            marginLeft: 'auto',
            marginRight: 'auto',
        },
    },

    margintop: {
        marginTop: theme.spacing(3),
    },
    marginleft: {
        marginLeft: theme.spacing(1),
    },
    marginbottom3: {
        marginBottom: theme.spacing(1),
        [theme.breakpoints.down('sm')]: {
            marginBottom: theme.spacing(3),
        },
    },
    checked: {
        '&, & + $label': {
            color: 'purple',
        },
    },
    label: {},

    radioLabel: {
        border: 'solid',
        borderWidth: '1px',
        borderColor: 'darkgrey',
        borderRadius: 25,
        padding: '0px 10px 0px 0px',
        margin: '0px 0px 0px 15px',
        fontSize: '12px',
        [theme.breakpoints.down('sm')]: {
            width: '48%',
            margin: '0px 0px 0px 5px',
            lineHeight: '1.2 !important',
            padding: '5px 0px 5px 1px',
        },
    },

    boldFont: {
        fontFamily: 'gt-walsheim-medium',
        lineHeight: '1.2 !important',
        [theme.breakpoints.down('sm')]: {
            lineHeight: '1.2 !important',
        },
    },
    button: {
        borderRadius: 20,
        textTransform: 'none',
        textAlign: 'left',
        letterSpacing: '0px',
        fontFamily: 'gt-walsheim-medium',
        fontSize: '16px',
        padding: '5px 25px',
        '@media (max-width: 372px)': {
            padding: '5px 8px',
            fontSize: '12px',
        },
        '@media (min-width:375px) and (max-width: 600px)': {
            padding: '5px 15px',
            fontSize: '12px',
        },
        [theme.breakpoints.up('sm')]: {
            padding: '5px 15px',
            fontSize: '14px',
        },
        [theme.breakpoints.up('md')]: {
            padding: '5px 25px',
            fontSize: '16px',
        },
        '&:focus,&:hover': {
            outline: 'none',
        },
    },
    greybutton: {
        marginLeft: theme.spacing(2),
        borderRadius: 20,
        textTransform: 'none',
        textAlign: 'left',
        letterSpacing: '0px',
        fontFamily: 'gt-walsheim-medium',
        fontSize: '1rem',
        padding: '5px 15px',
        '@media (max-width: 372px)': {
            padding: '5px 8px',
            fontSize: '12px',
            marginLeft: theme.spacing(1),
        },
        '@media (min-width:373px) and (max-width: 600px)': {
            padding: '5px 16px',
            fontSize: '12px',
            marginLeft: theme.spacing(1),
        },

        [theme.breakpoints.up('sm')]: {
            fontSize: '14px',
        },
        [theme.breakpoints.up('md')]: {
            fontSize: '16px',
        },
        '&:focus,&:hover': {
            outline: 'none',
        },
    },

    footer: {
        backgroundColor: '#ECECEC',
        position: 'fixed',
        bottom: 0,
        zIndex: 12,
        height: '80px',
        justifyContent: 'flex-end',
        [theme.breakpoints.down('xs')]: {
            height: '115px',
            justifyContent: 'center',
        },
    },
    table: {
        minWidth: 650,
    },
    prefernceRow: {
        backgroundColor: theme.palette.grey[200],
        minHeight: 42,
        textAlign: 'center',
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'center',
        fontFamily: 'gt-walsheim-medium',
        fontSize: '1rem',
    },
    tableRow: {
        backgroundColor: theme.palette.grey[200],
        minHeight: 42,
    },
    tableHeader: {
        minHeight: 40,
        fontFamily: 'gt-walsheim-medium',
    },
    prefernceHeader: {
        minHeight: 37,
        fontFamily: 'gt-walsheim-medium',
        [theme.breakpoints.down('sm')]: {
            fontSize: '13px',
            marginTop: theme.spacing(1.2),
        },
        '@media (min-width:321px) and (max-width: 767px)': {
            fontFamily: 'gt-walsheim-regular',
            fontStyle: 'normal',
            fontWeight: 'normal',
            fontSize: '16px',
        },
        '@media (min-width:318px) and (max-width: 320px)': {
            fontFamily: 'gt-walsheim-regular',
            fontStyle: 'normal',
            fontWeight: 'normal',
            fontSize: '12px',
        },
    },
    contactGroupNames: {
        marginLeft: theme.spacing(2),
        [theme.breakpoints.down('sm')]: {
            fontSize: '13px',
            marginTop: theme.spacing(1),
            marginLeft: theme.spacing(1),
        },
        [theme.breakpoints.up('sm')]: {
            fontSize: '14px',
            marginLeft: theme.spacing(1),
        },
        '@media (min-width:321px) and (max-width: 767px)': {
            fontFamily: 'eir-bold !important',
            fontStyle: 'normal !important',
            fontWeight: 'bold !important',
            fontSize: '16px !important',
        },
        '@media (min-width:318px) and (max-width: 321px)': {
            fontFamily: 'eir-bold !important',
            fontStyle: 'normal !important',
            fontWeight: 'bold !important',
            fontSize: '13px !important',
        },
    },
    permissionToolTip: {
        marginLeft: theme.spacing(1),
        marginTop: '4px',
    },
    centerAlign: {
        textAlign: 'center',
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'center',
    },
    rightAlign: {
        textAlign: 'right',
    },
    formLabelColor: {
        color: 'rgba(0, 0, 0, 0.87);',
        lineHeight: 1.5,
        marginBottom: 0,
        '@media (min-width:321px) and (max-width: 767px)': {
            fontFamily: 'gt-walsheim-regular',
            fontStyle: 'normal',
            fontWeight: 'normal',
            fontSize: '16px',
            lineHeight: '19px',
            letterSpacing: '0.15px',
        },
        '@media (min-width:318px) and (max-width: 321px)': {
            fontFamily: 'gt-walsheim-regular',
            fontStyle: 'normal',
            fontWeight: 'normal',
            fontSize: '13px',
            lineHeight: '19px',
            letterSpacing: '0.15px',
        },

    },
    formMobileLabelColor: {
        color: '#323435',
        lineHeight: 1.5,
        marginBottom: 0,
        height: '2.5rem',
        '@media (min-width:321px) and (max-width: 767px)': {
            fontFamily: 'gt-walsheim-regular',
            fontStyle: 'normal',
            fontWeight: 'normal',
            fontSize: '16px',
            lineHeight: '19px',
            letterSpacing: '0.15px',
            height: '4rem',
        },
        '@media (min-width:318px) and (max-width: 321px)': {
            fontFamily: 'gt-walsheim-regular',
            fontStyle: 'normal',
            fontWeight: 'normal',
            fontSize: '13px',
            lineHeight: '19px',
            letterSpacing: '0.15px',
            height: '4rem',
        },
    },
    errorMessage: {
        width: '100%',
        display: 'block',
        marginBottom: 0,
        fontSize: '0.75rem',
        color: '#e40046',
    },
    errorMessageCustMobile: {
        width: '100%',
        display: 'block',
        marginBottom: 0,
        fontSize: '0.75rem',
        color: '#e40046',
        lineHeight: '16px',
    },
    notifyMessage: {
        width: '100%',
        display: 'block',
        marginBottom: 0,
        fontSize: '0.8rem',
        color: '#e40046',
        paddingTop: '.8rem',
        paddingBottom: '.8rem',
    },
    errorMessageHeight: {
        height: '2.75rem',
        '@media (min-width:320px) and (max-width: 767px)': {
            height: '2rem',
        },

    },
    errorMessageHeightCalender: {
        height: '1.5rem',
    },
    errorMessageGender: {
        width: '100%',
        display: 'block',
        marginBottom: 0,
        fontSize: '0.75rem',
        color: '#e40046',
        '@media (min-width:320px) and (max-width: 767px)': {
            marginTop: '-2rem',
            marginBottom: '0.9rem',
        },
    },
    errorMessageMobile: {
        width: '100%',
        display: 'block',
        marginBottom: 0,
        fontSize: '0.75rem',
        color: '#e40046',
        top: '2.1rem',
        position: 'absolute',
        '@media (min-width:320px) and (max-width: 767px)': {
            marginTop: '0rem',
            marginBottom: '0.9rem',
        },
    },
    personalToolTip: {
        width: '10rem',
    },
    serviceErrorMessage: {
        width: '100%',
        marginTop: '.25rem',
        display: 'block',
        marginBottom: 0,
        marginLeft: '0.2rem',
        fontSize: '0.75rem',
        color: '#e40046',
        '@media (min-width:320px) and (max-width: 767px)': {
            marginTop: '0.5rem',
            marginLeft: '-0.29rem',
        },
    },
    eirCodeLogo: {
        height: '19px',
        paddingLeft: '7px',
        width: 'auto',
        [theme.breakpoints.down('sm')]: {
            height: '12px',
        },
        [theme.breakpoints.up('sm')]: {
            height: '16px',
        },
        [theme.breakpoints.up('md')]: {
            height: '19px',
        },
    },
    eirCodeLink: {
        textDecoration: 'none',
    },
    summaryButton: {
        borderRadius: 30,
        textTransform: 'none',
        textAlign: 'left',
        letterSpacing: '0px',
        fontFamily: 'gt-walsheim-regular',
        fontSize: 18,
        backgroundColor: primaryText,
        fontWeight: 'bold',
        padding: '10px 45px',
        margin: '17px 81px 0px 20px',
        [theme.breakpoints.down('sm')]: {
            fontSize: '16px',
            margin: '0px',
        },
        [theme.breakpoints.up('sm')]: {
            fontSize: '16px',
            marginTop: '20px',
        },
        [theme.breakpoints.up('md')]: {
            fontSize: '18px',
            margin: '17px 81px 0px 20px',
        },
        '&:focus,&:hover': {
            outline: 'none',
            backgroundColor:primaryText,
        },
    },
    summaryLabel: {
        fontSize: '24px',
        fontFamily: 'gt-walsheim-medium',
        color: primaryText,
        paddingTop: '20px',
        margin: theme.spacing(1, 2),
        [theme.breakpoints.down('sm')]: {
            fontSize: '24px',
            margin: theme.spacing(0),
            paddingTop: '10px',
        },
        [theme.breakpoints.up('sm')]: {
            marginTop: '8px',
        },
    },
    whiteCheckbox: {
        '&:not($checked) .MuiIconButton-label:after': {
            content: '""',
            left: 4,
            top: 4,
            height: 15,
            width: 15,
            position: 'absolute',
            backgroundColor: 'white',
            zIndex: -1,
            '@media (min-width:320px) and (max-width: 767px)': {
                backgroundColor: 'white !important',
                content: '""',
                position: 'absolute',
                zIndex: -1,
                height: 15,
                width: 15,
            },
        },
        color: 'grey',
        '& .MuiIconButton-label': {
            position: 'relative',
            zIndex: 0,
        },
        [theme.breakpoints.down('sm')]: {
            '&:not($checked) .MuiIconButton-label:after': {
                content: '""',
                left: 4,
                top: 4,
                height: 13,
                width: 13,
                position: 'absolute',
                backgroundColor: 'white',
                zIndex: -1,
            },
        },
    },
    preferenceName: {
        fontSize: '13px',
        fontFamily: 'gt-walsheim-medium',
        color: 'rgba(0, 0, 0, 0.87);',
        marginTop: '13px',
        [theme.breakpoints.up('sm')]: {
            fontSize: '14px',
        },
        '@media (min-width:321px) and (max-width: 767px)': {
            fontFamily: 'gt-walsheim-medium',
            fontStyle: 'normal',
            fontWeight: '600',
            fontSize: '14px',
        },
        '@media (min-width:318px) and (max-width: 320px)': {
            fontFamily: 'gt-walsheim-medium',
            fontStyle: 'normal',
            fontWeight: '600',
            fontSize: '12px',
        },
    },
    selectLabel: {
        fontSize: '16px',
        [theme.breakpoints.down('sm')]: {
            fontSize: '12px',
            minHeight: '30px',
        },
        [theme.breakpoints.up('md')]: {
            fontSize: '14px',
            minHeight: '35px',
        },
    },
    checkoutH1: {
        fontSize: '40px',
        [theme.breakpoints.down('sm')]: {
            fontSize: '24px',
            marginTop: '20px',
        },
    },

    mainContainer: {
        maxWidth: '1220px',
        margin: 'auto',
        '@media (min-width:768px) and (max-width: 1024px)': {
            paddingLeft: '15px',
            paddingRight: '15px',
        },
        '& .MuiSelect-icon': {
            color: '#D111C9',
        },
        '& .MuiRadio-colorSecondary.Mui-checked': {
            color: '#892BA0',
        },
        '& .Mui-focused fieldset': {
            borderColor: 'green',
        },
    },
    contactPaper: {
        padding: '3rem 1.2rem 1rem 1.2rem',
        marginTop: '1rem',
        '@media (min-width:320px) and (max-width: 767px)': {
            boxShadow: '0px 6px 6px -3px rgba(136, 139, 141, 0.2), 0px 10px 14px 1px rgba(136, 139, 141, 0.14), 0px 4px 18px 3px rgba(136, 139, 141, 0.12)',
            borderRadius: '10px',
            marginLeft: '15px',
            marginRight: '15px',
            paddingTop: '23px',
            paddingBottom: '23px'
        },
        '@media (min-width:768px) and (max-width:1023px)': {
            paddingTop: '23px',
            paddingBottom: '23px'
        },
    },
    contactTxt: {
        fontSize: '30px',
        color: '#323435',
        paddingBottom: '1rem',
        fontWeight: '400',
        '@media (min-width:321px) and (max-width: 767px)': {
            fontFamily: ' eir-medium',
            fontStyle: 'normal',
            fontWeight: 'normal',
            fontSize: '24px',
            lineHeight: '32px',
        },
        '@media (min-width:318px) and (max-width: 321px)': {
            fontFamily: ' eir-medium',
            fontStyle: 'normal',
            fontWeight: 'normal',
            fontSize: '22px !important',
        },
        '@media (min-width:767px) and (max-width: 1023px)': {
            fontSize: '22px !important',
            paddingBottom: 'none !important',
            width: '18rem',
        },
        '@media (min-width:1024px) and (max-width: 1025px)': {
            width: '22rem',
        },
    },
    questionIcon:
    {
        '@media (min-width:322px) and (max-width: 767px)': {
            marginLeft: '19px !important',
            marginTop: '4px !important',
        },
        '@media (min-width:318px) and (max-width: 321px)': {
            marginTop: '4px !important',
            marginLeft: '8px !important',
        },
        '@media (min-width:767px) and (max-width: 1023px)': {
            marginTop: '2px !important',
            marginLeft: '0 !important',
        },
        '@media (min-width:1024px) and (max-width: 1025px)': {
            marginLeft: '0rem !important',
        },
    },
    questionIconPersonal:
    {
        '@media (min-width:322px) and (max-width: 767px)': {
            marginLeft: '19px !important',
            marginTop: '4px !important',
        },
        '@media (min-width:318px) and (max-width: 321px)': {
            marginLeft: '1.5px !important',
            marginTop: '3px !important',
        },
        '@media (min-width:767px) and (max-width: 1023px)': {
            marginTop: '2px !important',
            marginLeft: '0.5rem !important',
        },
        '@media (min-width:1024px) and (max-width: 1025px)': {
            marginLeft: '0.5rem !important',
        },
    },

    reqText: {
        fontSize: '1rem',
        fontFamily: 'gt-walsheim-regular',
        textAlign: 'right',
    },
    reqTextMobileDetails: {
        fontSize: '1rem',
        fontFamily: 'gt-walsheim-regular',
        textAlign: 'right',
        color: '#323435',
        '@media (min-width:320px) and (max-width: 767px)': {
            paddingBottom: '22px',
            fontSize: '14px',
        },
    },
    reqTextInstallation: {
        fontSize: '1rem',
        fontFamily: 'gt-walsheim-regular',
        textAlign: 'right',
        '@media (min-width:320px) and (max-width: 767px)': {
            display: 'none',
        },
        '@media (min-width:768px) and (max-width: 1024px)': {
            display: 'block',
        },
    },
    reqTextInstallationMob: {
        display: 'none',
    },
    leftTxtBox: {
        marginLeft: '4rem',
    },
    gridDownSpace: {
        marginTop: '2.22rem',
        '@media (min-width:320px) and (max-width: 767px)':
        {
            marginTop: '1rem',
        },
        '@media (min-width:767px) and (max-width:1023px)':
        {
            marginTop: '1rem',
        },
        '@media (min-width:1024px) and (max-width:1025px)':
        {
            marginTop: '1.2rem',
        },

    },
    toolTip: {
        color: '#892BA0',
        marginTop: '10px',
    },
    toolTipText: {
        '& .MuiTooltip-tooltip.tooltip': {
            width: '100rem',
        },
    },
    mobileInfoTip: {
        color: '#892BA0',
        fontFamily: 'gt-walsheim-regular',
        fontSize: '.75rem',
        marginTop: '.25rem',
    },
    personalLabel: {
        fontFamily: 'gt-walsheim-regular',
        fontSize: '1rem',
        color: '#323435',
        paddingBottom: '1rem',
        marginRight: '2.65rem',

    },
    installationAgreementLabel: {
        fontFamily: 'gt-walsheim-regular',
        fontSize: '1rem',
        color: '#25262A',
    },
    installationMsgChkBox: {
        marginTop: '5px',
        fontFamily: 'gt-walsheim-regular',
        fontSize: '1rem',
        color: '#25262A',
    },
    dropDownMinWidth: {
        minWidth: '5rem',
        '@media (min-width:321px) and (max-width: 376px)': {
            minWidth: '4.9rem !important',
        },
        '@media (min-width:318px) and (max-width: 320px)': {
            minWidth: '122%',
        },
    },
    pageTitle: {
        color: '#323435',
        '@media (min-width:320px) and (max-width: 767px)': {
            fontFamily: 'eir-medium',
            fontStyle: 'normal',
            fontWeight: '400',
            fontSize: ' 24px',
            lineHeight: '32px',
            textAlign: 'center !important',
            paddingLeft: '24px',
            paddingRight: '24px',
            position: 'relative',
            top: '-3.7875rem',
        },
        '@media (min-width:767px) and (max-width: 1024px)': {
            fontSize: '25px',
        },
    },
    pageTitlePadding: {
        paddingTop: '3rem',
        '@media (min-width:320px) and (max-width: 767px)': {
            paddingTop: '60px',
            textAlign: 'center',
            justifyContent: 'center',
        },
        '@media (min-width:767px) and (max-width: 1023px)': {
            paddingTop: '2rem !important '
        },
    },
    pageInstallationTitlePadding: {
        paddingTop: '3rem',
        '@media (min-width:767px) and (max-width: 1023px)': {
            paddingTop: '2rem !important '
        },
    },
    titleText: {
        fontSize: '40px !important',
        '@media (min-width:320px) and (max-width: 767px)': {
            fontSize: '30px !important',
            textAlign: 'center',
            fontFamily: 'eir-medium',
            fontStyle: 'normal',
            fontWeight: '400',
            lineHeight: '38px',
            letterSpacing: '0.25px',
        },
        '@media (min-width:768px) and (max-width: 1023px)': {
            fontSize: '25px !important',
        },
        '@media (max-width: 1024px)': {
            fontSize: '30px !important',
        },

    },
    loginText: {
        color: '#323435',
        fontSize: '16px',
        fontFamily: 'gt-walsheim-regular',
        fontStyle: 'normal',
        fontWeight: 'normal',
        lineHeight: '24px',
        letterSpacing: '0.25px',
        paddingTop: '1.2rem',
        textAlign: 'right',
        '@media (min-width:320px) and (max-width: 767px)': {
            fontSize: '16px',
            textAlign: 'center',
            fontFamily: 'gt-walsheim-regular',
            fontStyle: 'normal',
            fontWeight: 'normal',
            lineHeight: '24px',
            letterSpacing: '0.25px',
            position: 'relative',
            top: '-6.5625rem',
        },
        '@media (min-width:768px) and (max-width: 1023px)': {
            fontSize: '14px !important',
            marginLeft: '-2rem',
            marginRight: '0.5rem',
            paddingTop: '0.8rem !important',
        },
        '@media (min-width:1024px) and (max-width: 1025px)': {
            fontSize: '15px !important',
            marginRight: '0.5rem',
            paddingTop: '0.6rem !important',

        },
    },
    loginTitle: {
        fontWeight: 'bold',
        fontSize: '1.25rem',
        marginLeft: '1rem',
        '@media (min-width:320px) and (max-width: 767px)': {
            fontSize: '20px',
            fontFamily: 'eir-bold',
            fontStyle: 'normal',
            fontWeight: 'bold',
            lineHeight: '26px',
            paddingLeft: '20px',
        },
    },
    loginTitleBottomPadding:
    {
        '@media (min-width:320px) and (max-width: 767px)': {
            paddingBottom: '30px',
        },
    },
    titlePadding: {
        paddingTop: '1.75rem',
        paddingBottom: '2rem',
        '@media (min-width:320px) and (max-width: 767px)': {
            height: '26px',
        },
    },
    loginSubTitle: {
        fontSize: '1rem',
        fontFamily: 'gt-walsheim-regular',
        color: '#323435',
        marginLeft: '1rem',
        '@media (min-width:320px) and (max-width: 767px)': {
            marginTop: '0 !important',
            fontFamily: 'gt-walsheim-regular',
            fontStyle: 'normal',
            fontWeight: ' normal',
            fontSize: '16px',
            lineHeight: '24px',
            paddingLeft: '20px',
        },
        '@media (min-width:768px) and (max-width: 1023px)': {
            marginTop: '0rem',
            fontSize: '14px !important',

        },
    },
    loginBankSubTitle: {
        fontSize: '1rem',
        fontFamily: 'gt-walsheim-regular',
        color: '#323435',
        marginLeft: '1rem',
        marginTop: '-1.5rem',
        '@media (min-width:320px) and (max-width: 767px)': {
            marginTop: '0 !important',
            fontFamily: 'gt-walsheim-regular',
            fontStyle: 'normal',
            fontWeight: ' normal',
            fontSize: '16px',
            lineHeight: '24px',
            paddingLeft: '20px',
            textAlign: 'justify',
        },

        '@media (min-width:768px) and (max-width: 1023px)': {
            marginTop: '-20px !important',
            fontSize: '14px !important',
        },
        '@media (min-width:1024px) and (max-width: 1025px)': {
            fontSize: '15px !important',
        },

    },
    loginBankSingleSubTitle: {
        fontSize: '1rem',
        fontFamily: 'gt-walsheim-regular',
        color: '#323435',
        marginLeft: '1rem',
    },
    loginTitleRightPadding: {
        marginRight: '1rem',
    },
    loginLink: {
        fontSize: '1rem',
        color: '#D111C9',
        fontFamily: 'gt-walsheim-regular',
        paddingTop: '1.2rem',
        textAlign: 'center',
        '@media (min-width:320px) and (max-width: 767px)': {
            fontSize: '16px',
            fontFamily: 'gt-walsheim-regular',
            fontStyle: 'normal',
            fontWeight: 'normal',
            lineHeight: '24px',
        },
        '@media (min-width:768px) and (max-width: 1023px)': {
            fontSize: '14px',
        },
    },
    dataOptionBackground: {
        backgroundImage: `url(${'/.galleries/checkout/background.png'})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: '4.1 rem !important',
        '@media (min-width:320px) and (max-width: 767px)': {
            position: 'relative',
            left: '15px',
            backgroundSize: 'contain',
            flexBasis: '13%',

        },
        '@media (min-width:768px) and (max-width: 1023px)': {
            backgroundSize: 'contain !important',

        },
        '@media (max-width: 1024px)': {
            backgroundSize: 'contain !important',

        },

    },
    iconPosition: {
        marginLeft: '1.2rem',
        marginTop: '1rem',
        '@media (min-width:322px) and (max-width: 767px)': {
            marginTop: '0 !important',
            marginLeft: '0 !important',
            height: '25px',
            position: 'relative',
            top: '6px',
            left: '12px',
        },
        '@media (min-width:410px) and (max-width: 415px)': {
            position: 'relative',
            top: '9px',
            left: '16px',
        },
        '@media (min-width:318px) and (max-width: 321px)': {
            position: 'relative',
            top: '-7px',
            left: '-9px',
        },
        '@media (min-width:358px) and (max-width: 370px)': {
            position: 'relative',
        },
        '@media (min-width:767px) and (max-width: 1023px)': {
            marginLeft: '0 !important',
            marginTop: '0 !important',
            height: '24px',
            width: '22px',
            position: 'relative',
            top: '3px !important',
            left: '10px !important',
        },
        '@media (min-width:1024px) and (max-width: 1025px)': {
            marginLeft: '0.9rem !important',
            marginTop: '0.6rem !important',
        },
    },
    iconSupplierPosition: {
        marginLeft: '0.9rem',
        marginTop: '0.9rem',
        '@media (min-width:322px) and (max-width: 767px)': {
            marginTop: '0 !important',
            marginLeft: '0 !important',
            height: '28px',
            width: '28px',
            position: 'relative',
            top: '7px',
            left: '10px',
        },
        '@media (min-width:410px) and (max-width: 415px)': {
            position: 'relative',
            top: '10px',
            left: '13px',
        },
        '@media (min-width:318px) and (max-width: 321px)': {
            position: 'relative',
            top: '-8px',
            left: '-7px',
        },
        '@media (min-width:358px) and (max-width: 370px)': {
            position: 'relative',
        },
        '@media (min-width:767px) and (max-width: 1023px)': {
            marginLeft: '0 !important',
            marginTop: '0 !important',
            height: '28px',
            width: '28px',
            position: 'relative',
            top: '3px !important',
            left: '7px !important',
        },
        '@media (min-width:1024px) and (max-width: 1025px)': {
            marginLeft: '0.6rem !important',
            marginTop: '0.5rem !important',
        },
    },
    iconBankPosition: {
        marginLeft: '0.8rem',
        marginTop: '0.8rem',
        '@media (min-width:322px) and (max-width: 767px)': {
            marginTop: '0 !important',
            marginLeft: '0 !important',
            height: '34px',
            width: '34px',
            position: 'relative',
            top: '6px',
            left: '7px',
        },
        '@media (min-width:410px) and (max-width: 415px)': {
            position: 'relative',
            top: '8px',
            left: '9px',
        },
        '@media (min-width:318px) and (max-width: 321px)': {
            position: 'relative',
            top: '-7px',
            left: '-6px',
        },
        '@media (min-width:358px) and (max-width: 365px)': {
            position: 'relative',
            top: '6px !important',
            left: '7px !important',
        },
        '@media (min-width:370px) and (max-width: 375px)': {
            position: 'relative',
            top: '6px !important',
            left: '8px !important',
        },
        '@media (min-width:767px) and (max-width: 1023px)': {
            marginLeft: '0 !important',
            marginTop: '0 !important',
            height: '33px',
            width: '33px',
            position: 'relative',
            top: '2px !important',
            left: '4px !important',
        },
        '@media (min-width:1024px) and (max-width: 1025px)': {
            marginLeft: '0.5rem !important',
            marginTop: '0.4rem !important',
        },

    },
    contactPadding: {
        paddingTop: '2rem',
        '@media (min-width:320px) and (max-width: 767px)': {
            // paddingLeft:'15px',
            // paddingRight:'15px',
            paddingTop: '2rem !important',
        }

    },
    personalPadding: {
        paddingTop: '2rem',
        paddingBottom: '2rem',
        '@media (min-width:320px) and (max-width: 767px)': {
            //paddingLeft:'15px',
            //paddingRight:'15px',
        },
    },
    personalPaddingInstallation:
    {
        '@media (min-width:320px) and (max-width: 767px)': {
            paddingBottom: '24px !important',
        },
    },
    mobilePadding: {
        paddingBottom: '2rem',
    },
    /* Payment Details ----start----- */
    pageTitlePaddingPayment: {
        paddingTop: '3rem',
        '@media (min-width:320px) and (max-width: 767px)': {
            paddingTop: '2.5rem !important',
        },
    },
    paymentHeading: {
        fontSize: '40px',
        '@media (min-width:320px) and (max-width: 768px)': {
            fontSize: '30px',
            lineHeight: '38px',
            textAlign: 'center',
            letterSpacing: '0.25px',
            fontFamily: 'eir-medium'
        },
        '@media (min-width:767px) and (max-width: 1024px)': {
            fontSize: '40px',
            textAlign: 'left',
            paddingLeft: '13px',
        },
    },
    paymentContainer: {
        '@media (min-width:320px) and (max-width: 768px)': {
            padding: '15px',
        },
    },
    debitInfoPadding: {
        paddingTop: '2rem',
        '@media (min-width:320px) and (max-width: 768px)': {
            paddingTop: '0 !important',
        },
    },
    PaymentPaper: {
        padding: '2rem',
        marginTop: '1rem',
        '@media (min-width:320px) and (max-width: 768px)': {
            paddingTop: '0 !important',
            paddingLeft: '24px',
            paddingRight: '24px',
            borderRadius: '10px',
        },
        '@media (width:320px)': {
            paddingLeft: '16px',
            paddingRight: '16px',
        },
    },
    gridDownSpacePayment: {
        marginBottom: '.5rem',
    },
    debitHeadingTxt1: {
        fontSize: '30px',
        color: '#323435',
        marginTop: '1rem',
        marginBottom: '1rem',
        '@media (min-width:320px) and (max-width: 768px)': {
            fontSize: '24px',
            fontStyle: 'normal',
            fontWeight: 'normal',
            lineHeight: '32px',
            marginTop: '25px',
            marginBottom: '25px',
        },
        '@media (min-width:767px) and (max-width: 1024px)': {
            fontSize: '30px',
        },
    },
    reqTextPayment: {
        fontSize: '1rem',
        fontFamily: 'gt-walsheim-regular',
        fontStyle: 'normal',
        fontWeight: '400',
        textAlign: 'right',
        marginTop: '1.5rem',
        '@media (min-width:320px) and (max-width: 768px)': {
            display: 'none',
        },
        '@media (min-width:767px) and (max-width: 1024px)': {
            display: 'block',
        },
    },
    reqTextPaymentMob: {    //for mobile view
        display: 'none',
        '@media (min-width:320px) and (max-width: 768px)': {
            fontSize: '1rem',
            fontFamily: 'gt-walsheim-regular',
            fontStyle: 'normal',
            fontWeight: '400',
            textAlign: 'right',
            marginTop: '-0.5rem',
            marginBottom: '1rem',
            display: 'block',
        },
        '@media (min-width:767px) and (max-width: 1024px)': {
            display: 'none',
        },
    },
    debitHeadingTxt2: {
        fontSize: '30px',
        color: '#323435',
        marginTop: '1rem',
        marginBottom: '1rem',
        '@media (min-width:320px) and (max-width: 768px)': {
            fontSize: '24px',
            fontStyle: 'normal',
            fontWeight: 'normal',
            lineHeight: '32px',
            marginTop: '25px',
            marginBottom: '25px',
        },
        '@media (min-width:767px) and (max-width: 1024px)': {
            fontSize: '30px',
        },
    },
    paymentFormLabelColor: {
        color: 'rgba(0, 0, 0, 0.87);',
        lineHeight: 1.5,
        marginBottom: 0,
        width: '1129px',
        fontFamily: 'gt-walsheim-regular',
        fontStyle: 'normal',
        fontWeight: '400',
        '@media (min-width:320px) and (max-width: 768px)': {
            width: '299px',
            fontSize: '16px',
            lineHeight: '19px',
            letterSpacing: '0.15px',
        },
        '@media (min-width:410px) and (max-width: 420px)': {
            width: '310px',
        },
        '@media (width:360px)': {
            width: '285px',
        },
        '@media (width:320px)': {
            width: '243px',
        },
        '@media (min-width:767px) and (max-width: 1024px)': {
            width: 'inherit',
        },
    },
    checkboxContainer: {
        marginTop: '2rem',
        marginLeft: '-.55rem',
        marginBottom: '2rem',
        '@media (min-width:320px) and (max-width: 768px)': {
            display: 'flex',
            marginLeft: '-1.55rem',
        },
        '@media (width:320px)': {
            marginLeft: '-.55rem',
        },
        '@media (min-width:767px) and (max-width: 1024px)': {
            marginLeft: '-.7rem',
        },
    },
    checkbox: {
        marginTop: '-5px',
        '@media (min-width:320px) and (max-width: 768px)': {
            marginTop: '-20px',
        },
        '@media (min-width:767px) and (max-width: 1024px)': {
            marginTop: '-8px',
        },
    },
    checkboxTxt: {
        color: 'rgba(0, 0, 0, 0.87);',
        lineHeight: '24px',
        marginBottom: 0,
        fontFamily: 'gt-walsheim-regular',
        fontStyle: 'normal',
        fontWeight: '400',
        fontSize: '16px',
    },
    errorMessageCheckbox: {
        width: '100%',
        marginTop: '-2rem',
        display: 'block',
        marginBottom: '2rem',
        fontSize: '0.75rem',
        color: '#e40046',
    },
    paymentLeftTxtBox: {
        minWidth: '345px',
        '@media (min-width:320px) and (max-width: 768px)': {
            minWidth: 'inherit',
            marginTop: '0.6rem',
        },
        '@media (min-width:767px) and (max-width: 1024px)': {
            minWidth: '315px',
            marginTop: '0',
        },
    },
    paymentRightTxtBox: {
        marginLeft: '25px',
        '@media (min-width:320px) and (max-width: 768px)': {
            marginTop: '2.5rem',
            marginLeft: '0',
        },
        '@media (min-width:767px) and (max-width: 1024px)': {
            minWidth: '315px',
            marginTop: '0',
            marginLeft: '25px',
        },
    },
    paymentRightDd: {
        marginLeft: '25px',
        '@media (min-width:320px) and (max-width: 768px)': {
            marginTop: '1.1rem',
            marginLeft: '0',
            marginBottom: '2rem',
        },
        '@media (min-width:767px) and (max-width: 1024px)': {
            minWidth: '315px',
            marginTop: '0',
            marginLeft: '25px',
        },
    },
    linkText: {
        fontSize: '.75rem',
        fontFamily: 'gt-walsheim-regular',
        fontStyle: 'normal',
        fontWeight: 'normal',
    },
    checkBankDetails: {
        marginBottom: '1.5rem',
        justifyContent: 'flex-end',
        '@media (min-width:320px) and (max-width: 768px)': {
            marginBottom: '0',
            marginTop: '1rem',
        },
        '@media (min-width:767px) and (max-width: 1024px)': {
            minWidth: '100%',
        },
    },
    checkBankDetailsItem: {
        '@media (min-width:320px) and (max-width: 768px)': {
            display: 'flex',
            justifyContent: 'center'
        },
    },
    checkBankDetailsBtn: {
        color: '#fff',
        height: '40px',
        width: '194px',
        borderRadius: '25px',
        fontSize: '1rem',
        fontFamily: 'eir-bold',
        textTransform: 'none',
        backgroundColor: '#d111c9',
        marginLeft: '-2.5rem',
        '&:focus,&:hover': {
            outline: 'none',
            color: '#fff',
            backgroundColor: '#d111c9',
        },
        '@media (min-width:320px) and (max-width: 768px)': {
            marginLeft: '0',
            backgroundColor: '#892ba0',
            '&:focus,&:hover': {
                backgroundColor: '#892ba0',
            },
        },
        '@media (min-width:767px) and (max-width: 1024px)': {
            marginLeft: '-5.8rem',
            backgroundColor: '#d111c9',
            '&:focus,&:hover': {
                backgroundColor: '#d111c9',
            },
        },
    },
    checkSuccess: {
        marginBottom: '1.5rem',
        maxHeight: '82px',
        maxWidth: '661px',
        height: '82px',
        boxSizing: 'border-box',
        border: '3px solid #43B02A',
        borderRadius: '10px',
        '@media (min-width:320px) and (max-width: 768px)': {
            minHeight: '114px',
            marginBottom: '0',
        },
        '@media (min-width:767px) and (max-width: 1024px)': {
            minHeight: '82px',
            minWidth: '500px',
        },
    },
    tickIcon: {
        background: `url(${'/.galleries/checkout/Tick.png'}) no-repeat center`,
        '@media (min-width:370px) and (max-width: 380px)': {
            maxWidth: '100px',
        },
        '@media (min-width:320px) and (max-width: 360px)': {
            maxWidth: '90px',
        },
        '@media (min-width:767px) and (max-width: 1024px)': {
            minWidth: '112px',
        },
    },
    successTxtContainer: {
        '@media (width:360px)': {
            minWidth: '170px',
        },
        '@media (width:320px)': {
            minWidth: '160px',
        },
        '@media (min-width:767px) and (max-width: 1024px)': {
            maxWidth: '75%',
        },
    },
    successTxt: {
        fontSize: '1rem',
        color: '#000000',
        fontFamily: 'eir-bold',
        marginBottom: '3px',
        marginTop: '1rem',
        '@media (min-width:320px) and (max-width: 768px)': {
            lineHeight: '20px',
            marginBottom: '10px',
        },
        '@media (width:320px)': {
            marginBottom: '3px',
            marginTop: '0.75rem',
        },
        '@media (min-width:767px) and (max-width: 1024px)': {
            marginBottom: '3px',
        },
    },
    changeBankDetails: {
        fontFamily: 'gt-walsheim-regular',
        color: 'rgba(50, 52, 53, 0.54)',
    },
    termsAndCondition: {
        paddingTop: '2rem',
    },
    TandCTitle: {
        fontSize: '30px',
        color: '#323435',
        marginTop: '1rem',
        marginBottom: '1rem',
        '@media (min-width:320px) and (max-width: 768px)': {
            fontSize: '24px',
            fontStyle: 'normal',
            fontWeight: 'normal',
            lineHeight: '32px',
            margin: '0',
            paddingTop: '23px',
            paddingBottom: '23px',
        },
        '@media (min-width:767px) and (max-width: 1024px)': {
            fontSize: '30px',
        },
    },
    TandCcheckboxContainer: {
        marginTop: '2rem',
        marginLeft: '-.55rem',
        '@media (min-width:320px) and (max-width: 768px)': {
            display: 'flex',
            marginLeft: '-1.55rem',
        },
        '@media (width:320px)': {
            marginLeft: '-.55rem',
        },
        '@media (min-width:767px) and (max-width: 1024px)': {
            marginLeft: '-.7rem',
        },
    },
    TandCcheckbox: {
        marginTop: '-5px',
        '@media (min-width:320px) and (max-width: 768px)': {
            marginTop: '-20px',
        },
        '@media (min-width:767px) and (max-width: 1024px)': {
            marginTop: '-8px',
        },
    },
    TCText: {
        fontSize: '1rem',
    },
    errorMessageTnC: {
        width: '100%',
        color: '#f44336',
        display: 'block',
    },
    paymentContinue: {
        marginBottom: '1.5rem',
        justifyContent: 'flex-end',
    },
    paymentContinueBtn: {
        color: '#fff',
        backgroundColor: '#d111c9',
        height: '40px',
        width: '117px',
        borderRadius: '25px',
        fontSize: '1rem',
        fontFamily: 'eir-bold',
        float: 'right',
        marginTop: '-4.2rem',
        textTransform: 'none',
        '&:focus,&:hover': {
            outline: 'none',
            color: '#fff',
            backgroundColor: '#d111c9',
        },
        '@media (min-width:320px) and (max-width: 768px)': {
            marginTop: '-2.55rem',
        },
        '@media (min-width:767px) and (max-width: 1024px)': {
            marginTop: '-3.3rem',
        },
    },
    paymentConfirmBtn:
    {
        color: '#fff',
        backgroundColor: '#d111c9',
        height: '40px',
        width: '164px',
        borderRadius: '25px',
        fontSize: '1rem',
        fontFamily: 'eir-bold',
        float: 'right',
        marginTop: '-4.2rem',
        textTransform: 'none',
        '&:focus,&:hover': {
            outline: 'none',
            color: '#fff',
            backgroundColor: '#d111c9',
        },
        '@media (min-width:320px) and (max-width: 768px)': {
            marginTop: '-2.55rem',
        },
        '@media (min-width:767px) and (max-width: 1024px)': {
            marginTop: '-3.3rem',
        },
    },
    // RemindMe ---Start
    modalContainer: {
        minWidth: '1020px',
        height: 'auto',
    },
    modalContent: {
        padding: '90px',
    },
    closeButton: {
        backgroundImage:
            'url(data:image/svg+xml;charset%3DUS-ASCII,%3Csvg%20id%3D%22Layer_1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%2024.1%2024.1%22%3E%3Cstyle%3E.st0%7Bfill%3A%23fff%7D%3C%2Fstyle%3E%3Cpath%20class%3D%22st0%22%20d%3D%22M15.1%2012l8.3-8.3c.8-.8.8-2.2%200-3s-2.2-.8-3%200L12.1%209%203.7.6c-.8-.8-2.2-.8-3%200-.8.8-.8%202.2%200%203L9%2012%20.7%2020.3l-.1.1c-.8.9-.7%202.2.1%203%20.9.8%202.2.7%203-.1L12%2015l8.3%208.3c.8.8%202.1.8%203%200%20.9-.8.9-2.2.1-3L15.1%2012z%22%2F%3E%3C%2Fsvg%3E)',
        backgroundRepeat: 'no-repeat',
        backgroundSize: '23px 23px',
        backgroundPosition: 'center',
        backgroundColor: '#54585A',
        width: '56px',
        minWidth: '56px',
        height: '56px',
        borderRadius: '40px',
        float: 'right',
        right: '-120px',
        top: '-120px',
        '&:focus,&:hover': {
            outline: 'none',
            backgroundColor: '#54585A',
        },
    },
    popupHeading: {
        color: '#25262A',
        textAlign: 'center',
        lineHeight: '2.25rem',
        marginLeft: '3rem',
        marginBottom: '2.2rem',
    },
    remindContainer: {
        padding: '0 25px 0 25px',
    },
    gridItemSpace: {
        marginBottom: '1rem',
    },
    popupLabel: {
        display: 'block',
        marginBottom: '.5rem',
        color: '#25262A',
        fontFamily: 'GT-Walsheim-Medium,"Arial Medium"',
        fontSize: '1.25rem',
        fontWeight: '400',
        lineHeight: '1.5rem',
    },
    popupInput: {
        marginBottom: '1rem',
        maxWidth: '640px',
        maxHeight: '48px',
        height: '48px',
        '.MuiOutlinedInput-root': {
            outline: 'none',
            borderColor: 'red',
            '&:focus,&:hover': {
                outline: 'none',
                borderColor: '#f36eee',
            },
        },
        '.MuiOutlinedInput-colorSecondary.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderWidth: '1px',
            borderColor: '#f36eee',
        },
        '.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: '#f36eee',
            '&:focus,&:hover': {
                borderColor: '#f36eee',
            },
        },
        '&:focus,&:hover': {
            outline: 'none',
            backgroundColor: '#fff',
            borderColor: '#f36eee',
            color: '#495057',
        },
    },
    remindMeBtn: {
        fontFamily: 'GT-Walsheim-Medium,"Arial Medium"',
        fontSize: '1.25rem',
        lineHeight: '1.5rem',
        borderRadius: '4px',
        padding: '11px 2rem',
        textTransform: 'none',
        height: '48px',
        width: '165px',
        backgroundColor: '#d111c9',
        color: '#fff',
        float: 'right',
        '&:focus,&:hover': {
            outline: 'none',
            backgroundColor: '#d111c9',
        },
    },
    errorMessagePayment: {
        width: '100%',
        display: 'block',
        marginBottom: 0,
        fontSize: '0.875rem',
        color: '#A5222A',
        textAlign: 'left',
    },
    remindMeErrorText: {
        color: '#25262A',
        marginBottom: '1.5rem',
    },
    remindMeErrorBtn: {
        fontFamily: 'GT-Walsheim-Medium,"Arial Medium"',
        fontSize: '1.25rem',
        lineHeight: '1.5rem',
        borderRadius: '4px',
        padding: '11px 2rem',
        textTransform: 'none',
        height: '48px',
        width: '150px',
        backgroundColor: '#d111c9',
        color: '#fff',
        float: 'right',
        '&:focus,&:hover': {
            outline: 'none',
            backgroundColor: '#d111c9',
        },
    },
    remindMeSuccessText: {
        fontFamily: 'GT-Walsheim-Bold,"Arial Bold"',
        fontWeight: '700',
        fontSize: '1.25rem',
        lineHeight: '1.5rem',
        color: '#25262A',
    },
    responseDetails: {
        fontFamily: 'GT-Walsheim-Regular,"Arial"',
        fontWeight: 'normal',
        fontSize: '1.25rem',
        lineHeight: '1.5rem',
        color: '#25262A',
    },
    remindMeSuccessBtn: {
        fontFamily: 'GT-Walsheim-Medium,"Arial Medium"',
        fontSize: '1.25rem',
        lineHeight: '1.5rem',
        borderRadius: '4px',
        padding: '11px 2rem',
        textTransform: 'none',
        height: '48px',
        width: 'auto',
        backgroundColor: '#d111c9',
        color: '#fff',
        float: 'right',
        '&:focus,&:hover': {
            outline: 'none',
            backgroundColor: '#d111c9',
        },
    },
    /* RemindMe ---end */
    /* Payment Details ----end----- */
    paddingRightItem: {
        paddingRight: '1rem',
        '@media (min-width:320px) and (max-width: 767px)': {
            paddingRight: '0rem',
        },
    },
    paddingRightTopItem: {
        paddingRight: '1rem',
        paddingTop: '2rem',
        '@media (min-width:320px) and (max-width: 767px)': {
            paddingRight: '0rem',
        },
    },
    mobilePaddingRightItem: {
        paddingRight: '1rem',
        '@media (min-width:768px) and (max-width: 1023px)': {
            paddingRight: '1.6rem !important',
        },
    },
    mobileDetailPaddingRight: {
        paddingRight: '2rem !important',
        paddingLeft: '16px !important',
        '@media (min-width:768px) and (max-width: 1023px)': {
            paddingRight: '1.6rem !important',
        },
    },
    paddingRightDOB: {
        paddingRight: '1rem',
        '@media (min-width:318px) and (max-width: 320px)': {
            paddingRight: '0rem !important',
        },
        '@media (min-width:321px) and (max-width: 767px)': {
            paddingRight: '0rem !important',
        },
    },
    paddingLeftItem: {
        paddingLeft: '1rem',
        '@media (min-width:320px) and (max-width: 767px)': {
            paddingLeft: '0rem',
        },
    },
    paddingRightItem: {
        paddingRight: '1rem',
    },
    paddingRightDOB: {
        paddingRight: '1rem',
        '@media (min-width:318px) and (max-width: 320px)': {
            paddingRight: '0rem !important',
        },
        '@media (min-width:321px) and (max-width: 767px)': {
            paddingRight: '0rem !important',
            paddingTop: '5px'
        },
        '@media (min-width:767px) and (max-width:1023px)': {
            paddingRight: '0rem !important',
            paddingTop: '0.5rem !important',
        },
    },
    paddingLeftItem: {
        paddingLeft: '1rem',
    },
    paddingLeftCalender: {
        paddingLeft: '1rem',
    },
    radioButtom: {
        maxHeight: '2.5rem',
        '@media (min-width:767px) and (max-width:1023px)': {
            paddingLeft: '0rem',
            maxHeight: 'fit-content',
        },
        '@media (min-width:1024px) and (max-width:1025px)': {
            paddingLeft: '0rem',
            maxHeight: 'fit-content',
        },
    },
    paddingTopMiddle: {
        paddingTop: '2rem',
    },
    btnNextStepper: {
        float: 'right',
        width: 'auto',
        marginTop: '2rem',
        padding: '.5rem 1.5rem .5rem 1.5rem',
        color: '#fff',
        height: '40px',
        borderRadius: '25px',
        fontSize: '1rem',
        fontFamily: 'eir-bold',
        textTransform: 'none',
        backgroundColor: '#d111c9',
        marginLeft: '-2.5rem',
        '&:focus,&:hover': {
            outline: 'none',
            color: '#fff',
            backgroundColor: '#d111c9',
        },
        '@media (min-width:321px) and (max-width: 767px)': {
            marginLeft: '0',
            backgroundColor: '#d111c9',
            marginRight: '15px',
            marginBottom: '57px',
            paddingTop: '6px',
            '&:focus,&:hover': {
                backgroundColor: '#d111c9',
            },
        },
        '@media (min-width:318px) and (max-width: 320px)': {
            paddingLeft: '10px',
            paddingRight: '10px',
            marginRight: '15px',
            marginBottom: '57px',
            paddingTop: '6px',
        },
        '@media (min-width:768px) and (max-width: 1023px)': {
            marginLeft: '-5.8rem',
            paddingTop: '6px',
            backgroundColor: '#d111c9',
            marginBottom: '57px',
            '&:focus,&:hover': {
                backgroundColor: '#d111c9',
            },
        },
        '@media (min-width:1024px) and (max-width: 1025px)': {
            paddingTop: '5px',
            marginBottom: '57px',

        },
    },
    calenderIcon: {
        display: 'inline-block',
        width: '23px',
        textAlign: 'center',
        outline: 'none',
        height: '26px',
        backgroundImage:
            'url("/opencms/export/sites/default/.galleries/checkout/calendar-today.png")',
        backgroundRepeat: 'no-repeat',
        '&:focus,&:hover': {
            outline: 'none',
        },
        '@media (max-width: 767px)': {
            // marginRight: '-12px',
        },
        '@media (min-width:767px) and (max-width: 1024px)': {
            //  marginRight: '-20px',
        },
    },
    masterSocket: {
        backgroundColor: 'white !important',
        padding: '0px 0px 0px 0px !important',
        opacity: 'inherit !important',

    },
    masterSocketImg: {
        width: '26rem',
        height: '22rem',
    },
    masterSocketText: {
        width: '26rem',
        padding: '0rem 0rem 0rem 0rem',
        fontWeight: 'bold',
    },
    /*Order Confirmation -----start----- */

    pageTitlePaddingConfirmation: {
        paddingTop: '3rem',
        '@media (min-width:320px) and (max-width: 768px)': {
            paddingTop: '1rem !important',
        },
        '@media (min-width:768px) and (max-width: 1024px)': {
            paddingTop: '3rem !important',
            marginLeft: '1rem',
        },
    },

    confirmationMainContainer: {
        maxWidth: '1220px',
        margin: 'auto',
        '& .MuiSelect-icon': {
            color: '#D111C9 !important',
        },
        '& .MuiRadio-colorSecondary.Mui-checked': {
            color: '#892BA0',
        },
        '& .Mui-focused fieldset': {
            borderColor: 'green',
        },
        '@media (min-width:320px) and (max-width: 767px)': {
            padding: '15px'
        },
    },
    ConfirmationPaper: {
        padding: '2rem',
        marginTop: '2rem',
        marginBottom: '4rem',
        maxWidth: '1200px',
        '@media (min-width:320px) and (max-width: 767px)': {
            padding: '1.75rem',
            marginLeft: '0',
            width: 'inherit',
            marginTop: '1rem',
        },
        '@media (min-width:767px) and (max-width: 1024px)': {
            width: '705px',
            marginLeft: '2rem',
        },
        '@media (min-width:1024px) and (max-width: 1366px)': {
            width: '963px',
            marginLeft: '2rem',
        },
        '@media (width:320px)': {
            padding: '1.5rem',
        },
    },
    confirmContainer: {
        marginLeft: '-1.8rem',
        '@media (min-width:320px) and (max-width: 767px)': {
            marginLeft: '0',
        },
        '@media (min-width:767px) and (max-width: 1024px)': {
            marginLeft: '-2.8rem',
            maxWidth: '100%',
        },
        '@media (min-width:1024px) and (max-width: 1366px)': {
            maxWidth: '100%',
            marginLeft: '-1.8rem',
        },
    },
    iconContainer: {
        '@media (min-width:320px) and (max-width: 767px)': {
            marginLeft: '-1.2rem',
        },
        '@media (min-width:410px) and (max-width: 420px)': {
            marginLeft: '-1.7rem',
        },
        '@media (width:320px)': {
            marginLeft: '-0.5rem',
        },
        '@media (min-width:1024px) and (max-width: 1366px)': {
            marginLeft: '-2.8rem',
        },
    },
    ellipse: {
        background: `url(${'/.galleries/checkout/Ellipse.png'}) no-repeat center`,
        textAlign: 'center',
        height: '85px',
    },
    confirmationtickIcon: {
        width: '45px',
        height: '37px',
        marginTop: '1.4rem'
    },
    OrderSuccess: {
        '@media (min-width:1024px) and (max-width: 1366px)': {
            marginLeft: '-2.8rem',
        },
    },
    OrderSuccessTxt: {
        fontSize: '30px',
        fontFamily: 'eir-medium',
        fontStyle: 'normal',
        fontWeight: 'normal',
        marginTop: '0.5rem',
        marginBottom: '8px',
        lineHeight: '38px',
        letterSpacing: '0.25px',
        '@media (min-width:320px) and (max-width: 767px)': {
            fontSize: '24px',
            marginBottom: '0',
        },
        '@media (width:320px)': {
            fontSize: '20px',
        },
    },
    orderNo: {
        fontSize: '20px',
        fontFamily: 'eir-medium',
        fontStyle: 'normal',
        fontWeight: 'normal',
        lineHeight: '26px',
        letterSpacing: '0.25px',
        '@media (min-width:320px) and (max-width: 767px)': {
            fontSize: '16px',
            marginBottom: '0',
        },
        '@media (width:320px)': {
            fontSize: '14px',
        },
    },
    successMessage: {
        marginTop: '1rem',
        '@media (min-width:767px) and (max-width: 1024px)': {
            maxWidth: '100%',
        },
    },

    /*Order Confirmation -----end----- */
    pageInstallationHeading: {
        fontSize: '40px !important',
    },


    /************************Mobile View Chnages********************/
    '@media (min-width:320px) and (max-width: 767px)': {
        pageInstallationHeading: {
            fontFamily: 'eir-medium',
            fontStyle: 'normal',
            fontWeight: 'normal',
            fontSize: '30px !important',
            lineHeight: '38px',
            textAlign: 'center',
            letterSpacing: '0.25px',
            marginTop: '-14px',
            marginBottom: '-23px',
            paddingBottom: '40px',
        },
        pageInstallationTitlePadding: {
            paddingTop: '40px',
            textAlign: 'center',
            justifyContent: 'center',
        },

        contactPaper: {
            paddingTop: '23px',
            paddingLeft: '22px',
            marginBottom: '11px',
            marginLeft: '15px',
            marginRight: '15px',
        },
        contactTxt: {
            fontFamily: 'eir-medium',
            fontStyle: 'normal',
            fontWeight: 'normal',
            fontSize: '24px',
        },
        paddingLeftItem: {
            paddingLeft: 0,
        },
        errorMessageGender: {
            marginBottom: '0.9rem',
            marginTop: '-2rem',
        },
        errorMessageHeightCalender: {
            height: '2rem',
        },
        personalLabel: {
            fontFamily: 'gt-walsheim-regular',
            fontStyle: 'normal',
            fontWeight: 'normal',
            fontSize: '16px !important',
            lineHeight: '19px',
            alignItems: 'center',
            letterSpacing: '0.15px',
            paddingRight: '28px',
            marginRight: '14px',
        },
        installationAgreementLabel: {
            fontFamily: 'gt-walsheim-regular',
            fontStyle: 'normal',
            fontWeight: 'normal',
            fontSize: '16px',
            lineHeight: '19px',
            alignItems: 'center',
            letterSpacing: '0.15px',
            //paddingRight: '28px',        
        },
        installationMsgChkBox: {
            marginTop: '-5px',
            fontFamily: 'gt-walsheim-regular',
            fontSize: '1rem',
            color: '#25262A',
            //color: 'green', 
        },
        paddingTopMiddle: {
            paddingTop: '0',
        },
        paddingRightItem: {
            paddingRight: '0',
        },
        mobilePaddingRightItem: {
            paddingRight: '0',
        },
        mobileDetailPaddingRight: {
            paddingRight: '8px !important',
        },
        radioButtom: {
            maxHeight: 'fit-content',
        },
        paddingLeftCalender: {
            paddingLeft: '0',
            marginTop: '1.50rem',
            '& .MuiOutlinedInput-adornedEnd': {
                paddingRight: '0px !important',
            },
        },

        MuiOutlinedInputmarginDense: {
            marginBottom: '2.75rem !important',
        },
        masterSocket: {
            padding: '0px 0px 0px 0px !important',
            width: '90% !important',
            marginLeft: '-1.4rem !important',
        },
        questionEquipment: {
            '& .__react_component_tooltip.place-top:before': {
                marginLeft: '-7rem !important',
            },
        },

        masterSocketImg: {
            width: '22rem',
            height: '18rem',
            padding: '1rem 4rem 1.2rem 2rem',
        },
        masterSocketText: {
            width: '26rem',
            padding: '0rem 6rem 1.2rem 1.25rem',
            fontWeight: 'bold',
        },

        reqTextInstallationMob: {    ///mobileView
            fontFamily: 'gt-walsheim-regular',
            fontStyle: 'normal',
            fontWeight: 'normal',
            fontSize: '16px',
            lineHeight: '19px',
            letterSpacing: '0.15px',
            marginLeft: '11rem',
            marginBottom: '1.5rem',
            display: 'block',
        },
        questionEquipment: {
            position: 'relative',
            marginTop: '-2.3rem',
            marginLeft: '8.5rem !important',
        },
        questionInstallationInfo: {
            position: 'relative',
            marginTop: '-2.3rem',
            marginLeft: '8rem',
        },

    },

    '@media (max-width: 320px)': {
        personalLabel: {
            paddingRight: '16px',
        },
        installationAgreementLabel: {
            paddingRight: '0px',
        },
        installationMsgChkBox: {
            marginTop: '-5px',
            fontFamily: 'gt-walsheim-regular',
            fontSize: '1rem',
            color: '#25262A',
            //color: 'red', 
        },
        reqTextInstallationMob: {
            marginLeft: '7.7rem',
        },
        questionEquipment: {
            marginLeft: '11.6rem !important',
        },
        questionInstallationInfo: {
            marginLeft: '10rem',
        },
        dropDownMinWidth: {
            minWidth: '0 !important'
        },
        masterSocket: {
            marginLeft: '-4.6rem !important',
            width: '19rem !important',
        },
    },
    '@media (min-width:321px) and (max-width: 365px)': {
        reqTextInstallationMob: {
            marginLeft: '10.1rem',
        },
        questionEquipment: {
            marginLeft: '12rem !important',
        },
        masterSocket: {
            marginLeft: '-3rem !important',
            width: '21rem !important',
        },
    },
    '@media (min-width:400px) and (max-width: 600px)': {
        contactPaper: {
            paddingRight: '41px',
        },
        reqTextInstallationMob: {
            marginLeft: '12.1rem',
        },
        questionInstallationInfo: {
            marginLeft: '4.2rem',
        },
        questionEquipment: {
            marginLeft: '8.5rem !important',
        },
        masterSocket: {
            marginLeft: '3% !important',
            width: '90% !important',
        },
        masterSocketImg: {
            padding: '1rem 1rem 1.2rem 2rem',
        },
        masterSocketText: {
            padding: '0rem 4rem 1.2rem 1.25rem',

        },
    },
    '@media (min-width:768px) and (max-width: 1024px)': {
        paddingLeftCalender: {
            '& .MuiOutlinedInput-adornedEnd': {
                paddingRight: '0px !important',
            },
        },
    },
    paymentArea: {
        paddingTop: '2rem',
        '@media (min-width:320px) and (max-width: 768px)': {
            paddingTop: '15px !important',
            paddingLeft: '15px',
            paddingRight: '14px',
        },
    },
    paymentPaper: {
        '@media (min-width:320px) and (max-width: 768px)': {
            // width:'345px',
        },
    },
    iframePay: {
        width: '600px',
        height: '722px',
        display: 'none',
        border: 'none',
        '@media (min-width:320px) and (max-width: 767px)': {
            width: '299px',
            height: '750px !important'
        },
        '@media (width:320px)': {
            width: '250px',
        },
        '@media (min-width:768x) and (max-width: 1024px)': {
            height: '568px !important'
        },
        '@media (min-width:1024x) and (max-width: 1023px)': {
            height: '568px !important'
        },
    },
    IframePanel: {
        padding: '50px 0px 20px 0px',
        textAlign: '-webkit-center',
        '@media (min-width:320px) and (max-width: 767px)': {
            padding: '33px 23px 40px 22px',
        },
        '@media (min-width:321px) and (max-width: 360px)': {
            paddingLeft: '16px'
        },
        '@media (min-width:410px) and (max-width: 415px)': {
            paddingRight: '21px'
        },
        '@media (width:320px)': {
            padding: '33px 23px 40px 22px',
        },
    },
    IframePanelText: {
        fontSize: '30px',
        color: '#323435',
        paddingTop: '50px',
        paddingLeft: '295px',
        '@media (min-width:320px) and (max-width: 767px)': {
            fontSize: '24px',
            paddingTop: '23px',
            paddingLeft: '22px',
        },
        '@media (width:320px)': {
            fontSize: '24px',
            paddingTop: '23px',
            paddingLeft: '22px',
        },
    },
    loadingPadding: {
        paddingTop: '100px',
    },
    paymentBackButtons: {
        marginBottom: '80px',
        '@media (min-width:320px) and (max-width: 767px)': {
            marginTop: '-25px',
            marginBottom: '19px',
        },
        '@media (width:320px)': {
            marginTop: '-25px',
            marginBottom: '19px',
        },
    },
    accountPrefix:
    {

        '@media (min-width:322px) and (max-width: 767px)': {
            marginBottom: '2rem',
        },
        '@media (min-width:318px) and (max-width: 321px)': {
            marginBottom: '2rem',
        },
        '@media (min-width:767px) and (max-width: 1023px)': {
            marginRight: '10px !important',
        },
        '@media (min-width:1024px) and (max-width: 1025px)': {
            marginRight: '10px !important',
        },
    },
    accountMobilePrefix:
    {
        paddingRight: '0px !important',
        '@media (min-width:322px) and (max-width: 767px)': {
            marginBottom: '2rem',
        },
        '@media (min-width:318px) and (max-width: 321px)': {
            marginBottom: '2rem',
        },
        '@media (min-width:767px) and (max-width: 1023px)': {
            marginRight: '10px !important',
        },
        '@media (min-width:1024px) and (max-width: 1025px)': {
            marginRight: '10px !important',
            minWidth: '6.5rem !important',
        },
    },
    IBNErrorTxt: {
        marginTop: '-3rem',
        color: 'red',
        fontFamily: 'eir-bold',
        marginBottom: '3px',
        fontSize: '0.8rem',
        '@media (min-width:321px) and (max-width: 767px)': {
            marginTop: '0rem',
        },
        '@media (min-width:318px) and (max-width: 321px)': {
            marginTop: '0rem',
        },
        '@media (min-width:767px) and (max-width: 1023px)': {
            marginTop: '0rem',
        },
        '@media (min-width:1024px) and (max-width: 1025px)': {
            marginTop: '0rem',
        },
    },
    installationMsgArea: {
        padding: '.5rem 0rem .5rem .75rem',
        backgroundColor: '#888b8d',
        marginBottom: '1.5rem',
    },
    installationMsg: {
        color: '#FFFFFF',
    },
    iconSimBlackLight: {
        backgroundImage:
            'url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2224%22%20height%3D%2216%22%20viewBox%3D%220%200%2024%2016%22%3E%20%20%3Cdefs%3E%20%20%20%20%3Cstyle%3E%20%20%20%20%20%20.cls-1%20%7B%20%20%20%20%20%20%20%20fill%3A%20%2325262A%3B%20%20%20%20%20%20%20%20fill-rule%3A%20evenodd%3B%20%20%20%20%20%20%7D%20%20%20%20%3C%2Fstyle%3E%20%20%3C%2Fdefs%3E%20%20%3Cpath%20id%3D%22SIM%22%20class%3D%22cls-1%22%20d%3D%22M625.429%2C2378.4a1.663%2C1.663%2C0%2C0%2C1-1.715-1.6v-6.96l4.987-4.24h13.837a1.694%2C1.694%2C0%2C0%2C1%2C1.748%2C1.6v9.6a1.663%2C1.663%2C0%2C0%2C1-1.715%2C1.6H625.429Zm17.142%2C1.6a3.325%2C3.325%2C0%2C0%2C0%2C3.429-3.2v-9.6a3.278%2C3.278%2C0%2C0%2C0-3.429-3.2H628.047L622%2C2369.23v7.57a3.325%2C3.325%2C0%2C0%2C0%2C3.429%2C3.2h17.142Zm-2.87-9.32c0.947%2C0%2C1.094.1%2C1.094%2C0.99v2.49c0%2C0.88-.113.99-1.06%2C0.99h-4.488c-0.947%2C0-1.06-.11-1.06-0.99v-2.49c0-.89.113-0.99%2C1.06-0.99h2.805s-0.02-1.6-.022-1.6h-2.783c-1.894%2C0-2.774.82-2.774%2C2.59v2.49c0%2C1.76.88%2C2.59%2C2.774%2C2.59h4.488c1.894%2C0%2C2.774-.83%2C2.774-2.59v-2.49c0-1.8-.845-2.59-2.774-2.59C639.733%2C2369.08%2C639.7%2C2370.68%2C639.7%2C2370.68Zm-1.775-.02a0.883%2C0.883%2C0%2C0%2C0%2C.659-0.85%2C0.932%2C0.932%2C0%2C0%2C0-.66-0.78m1.967%2C0a0.881%2C0.881%2C0%2C0%2C0-.658.85%2C0.93%2C0.93%2C0%2C0%2C0%2C.659.78%22%20transform%3D%22translate%28-622%20-2364%29%22%2F%3E%3C%2Fsvg%3E)',
        backgroundRepeat: 'no-repeat',
        width: '50px',
        height: '45px',
        backgroundSize: '50px 45px',
    },
    iconSimBlackText: {
        margin: '1.25rem 0rem 0rem -2rem',
        color: '#888886',
        '@media (min-width:321px) and (max-width: 767px)': {
            margin: '1.25rem 0rem 0rem 1rem',
        },
        '@media (min-width:318px) and (max-width: 321px)': {
            margin: '1.25rem 0rem 0rem 1rem',
        },
        '@media (min-width:767px) and (max-width: 1023px)': {
            margin: '1.25rem 0rem 0rem 1rem',
        },
        '@media (min-width:1024px) and (max-width: 1025px)': {
            margin: '1.25rem 0rem 0rem 1rem',
        },
    }

}));
